import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

const f0 = new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 });
const R = (v) => `${v < 0 ? "-" : ""}Rs ${f0.format(Math.abs(Math.round(v || 0)))}`;
const P = (v) => (v === "new" ? "new" : v === null ? "-" : `${v > 0 ? "+" : ""}${(v * 100).toFixed(1)}%`);
const DARK = [30, 41, 59], AMBER = [217, 119, 6];
const head = { fillColor: DARK, textColor: 255, fontStyle: "bold", fontSize: 8.5 };
const foot = { fillColor: [254, 243, 199], textColor: [120, 53, 15], fontStyle: "bold", fontSize: 8.5 };

export function exportComparePdf({ business, labelA, labelB, subtitle, kpis, declines, growth, cats }) {
  const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "a4" });
  const w = doc.internal.pageSize.getWidth();
  doc.setFillColor(...AMBER); doc.rect(0, 0, w, 6, "F");
  doc.setFont("helvetica", "bold"); doc.setFontSize(15); doc.setTextColor(...DARK);
  doc.text(business || "MANJAP HOSPITALITY SOLUTIONS", 40, 36);
  doc.setFontSize(12); doc.text("Sales Comparison", 40, 56);
  doc.setFont("helvetica", "normal"); doc.setFontSize(9); doc.setTextColor(100);
  doc.text(subtitle || `${labelB}   vs   ${labelA}`, 40, 72);
  doc.text(`Generated ${new Date().toLocaleString("en-IN")}`, w - 40, 72, { align: "right" });

  const sec = (title, y) => { doc.setFontSize(11); doc.setTextColor(...DARK); doc.setFont("helvetica", "bold"); doc.text(title, 40, y); return y + 10; };
  const last = () => doc.lastAutoTable.finalY;

  autoTable(doc, {
    startY: sec("Totals", 100), theme: "grid", headStyles: head, styles: { fontSize: 9, cellPadding: 5 }, margin: { left: 40, right: 40 },
    columnStyles: { 1: { halign: "right" }, 2: { halign: "right" }, 3: { halign: "right" }, 4: { halign: "right" } },
    head: [["Measure", labelA, labelB, "Difference", "Change"]],
    body: kpis.map((k) => [k.label, k.fmt(k.a), k.fmt(k.b), k.fmt(k.b - k.a), P(k.change)]),
  });

  autoTable(doc, {
    startY: sec(`Sales DOWN vs ${labelA} (${declines.length} items)`, last() + 26), theme: "striped", headStyles: head, footStyles: foot,
    styles: { fontSize: 8.5, cellPadding: 4 }, margin: { left: 40, right: 40 },
    columnStyles: { 2: { halign: "right" }, 3: { halign: "right" }, 4: { halign: "right" }, 5: { halign: "right" }, 6: { halign: "right" } },
    head: [["Item", "Category", `Qty ${labelA}`, `Qty ${labelB}`, labelA, labelB, "Difference"]],
    body: declines.length ? declines.map((i) => [i.name, i.category, i.qtyA, i.qtyB, R(i.a), R(i.b), R(i.diff)])
      : [["No item dropped in this period", "", "", "", "", "", ""]],
    foot: [["TOTAL DROP", "", "", "", "", "", R(declines.reduce((s, i) => s + i.diff, 0))]],
  });

  autoTable(doc, {
    startY: sec(`Sales UP - target these (${growth.length} items)`, last() + 26), theme: "striped", headStyles: head, footStyles: foot,
    styles: { fontSize: 8.5, cellPadding: 4 }, margin: { left: 40, right: 40 },
    columnStyles: { 2: { halign: "right" }, 3: { halign: "right" }, 4: { halign: "right" }, 5: { halign: "right" }, 6: { halign: "right" } },
    head: [["Item", "Category", `Qty ${labelA}`, `Qty ${labelB}`, labelA, labelB, "Difference"]],
    body: growth.length ? growth.map((i) => [i.name, i.category, i.qtyA, i.qtyB, R(i.a), R(i.b), R(i.diff)])
      : [["No item grew in this period", "", "", "", "", "", ""]],
    foot: [["TOTAL GAIN", "", "", "", "", "", R(growth.reduce((s, i) => s + i.diff, 0))]],
  });

  if (last() > doc.internal.pageSize.getHeight() - 160) doc.addPage();
  autoTable(doc, {
    startY: sec("Category-wise", last() + 26), theme: "grid", headStyles: head, styles: { fontSize: 9, cellPadding: 4 },
    margin: { left: 40, right: 40 }, tableWidth: 520,
    columnStyles: { 1: { halign: "right" }, 2: { halign: "right" }, 3: { halign: "right" }, 4: { halign: "right" } },
    head: [["Category", labelA, labelB, "Difference", "Change"]],
    body: cats.map((c) => [c.name, R(c.a), R(c.b), R(c.diff), P(c.change)]),
  });

  const n = doc.internal.getNumberOfPages();
  for (let i = 1; i <= n; i++) {
    doc.setPage(i);
    doc.setFontSize(7); doc.setTextColor(140);
    doc.text("Manjap Sales Comparison  -  Good Food. Great Mood.", 40, doc.internal.pageSize.getHeight() - 18);
    doc.text(`Page ${i} of ${n}`, w - 40, doc.internal.pageSize.getHeight() - 18, { align: "right" });
  }
  doc.save(`Manjap_Comparison_${labelB.replace(/\s+/g, "_")}_vs_${labelA.replace(/\s+/g, "_")}.pdf`);
}
